<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import {
  splitSentencesByDivider,
  transformMarkedText,
  splitBySentence,
  transformForTitle,
} from '@/composables/splitSentence';

import PersonalityKeyword from './PersonalityKeyword.vue';
import PersonalFiveChart from './PersonalFiveChart.vue';
import SpeechBubbleTail from '@/components/svg/SpeechBubbleTail.vue';

const props = defineProps({
  pData: Object,
  pSubData: Object,
  userName: String,
  isMobile: Boolean,
});

const mainTitle = computed(() =>
  transformForTitle(props.pData.전체성향요약?.성향요약 || props.pSubData?.성향요약),
);

/** 차트 데이터 */
const chartData = computed(() => props.pData?.종합분석 || props.pSubData);

const pKeyword = computed(() => props.pData?.전체성향요약?.카테고리 || props.pSubData?.카테고리);
const pKeywordDesc = computed(
  () => props.pData?.전체성향요약?.요약풀이 || props.pSubData?.요약풀이,
);
const rawPersonalityTxt = computed(
  () => props.pData?.종합분석?.종합오행분석?.성향분석 || props.pSubData?.종합오행분석?.성향분석,
);
const parsedPT = computed(() => {
  const sentences = splitBySentence(rawPersonalityTxt.value || '');
  return sentences.map((sentence) => transformMarkedText(sentence));
});

const defaultPersonality = computed(() =>
  splitBySentence(props.pData?.전체성향요약?.기본특성 || props.pSubData?.기본특성),
);
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="detail-card__top-title personality">
          <span class="detail-tit__num personality">1</span>
          <span class="detail-tit__txt personality">
            <span>사주명리의 시선으로 바라 본,&nbsp;</span>
            <span>나를 구성하는 오행의 기운 흐름</span>
          </span>
        </div>
        <div class="personality-wrapper with-tit">
          <div class="person-content-box">
            <!-- <div class="tit-section">
              <div  class="person-main-title" v-html="mainTitle"/>
              <div class="main-title__underline" />
            </div> -->
            <div class="tit-section">
              <div class="person-main-title">
                <span class="tit-line">{{ mainTitle[0] }}</span>
                <span class="tit-line">
                  {{ mainTitle[1] }}
                  <div class="main-title__underline" />
                </span>
              </div>
            </div>

            <div class="person-desc-txt">
              음양과 오행의 균형 속에서 드러난 {{ userName }}님의 성향을 전체적으로 요약해 정리한<br />
              종합 분석입니다.
            </div>
          </div>

          <div class="person-content-box chart bar-line-chart">
            <PersonalFiveChart :chartData="chartData" :chartType="'total'" />
          </div>

          <div class="person-content-box">
            <PersonalityKeyword
              :left-title="['나의 성향,', '나의 모습들! 😊']"
              :keywords="props.pData?.전체성향요약?.주요특징 || props.pSubData?.주요특징"
              background-color="primary"
              :icon-color="isMobile ? '#333333' : 'white'"
              :isMobile="isMobile"
            />
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">🧡 나의 성향 키워드</div>
            <div class="desc__body gray">
              <div class="personality-keyword">
                <div class="keyword-bubble">
                  {{ pKeyword }}
                  <SpeechBubbleTail :color="'#db9823'" class="personality-keyword__tail" />
                </div>
              </div>
              <span class="desc__body-txt">{{ pKeywordDesc }}</span>
            </div>
          </div>
          <div class="person-content-box">
            <div class="content__title">🌈 가장 선명한 나의 성향</div>
            <div v-for="(html, idx) in parsedPT" :key="idx">
              <span class="content__body-txt" v-html="html" />
            </div>
          </div>

          <div class="personality-divider" />

          <div class="person-content-box">
            <div class="content__title">🙌 나는 어떤 결을 가지고 있을까요!</div>
            <div v-for="(sentence, idx) in defaultPersonality" :key="idx">
              <span class="content__body-txt" v-html="transformMarkedText(sentence)" />
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
